/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/infiltrate_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M6.5 16c0-5.238 4.262-9.5 9.5-9.5s9.5 4.262 9.5 9.5a9.428 9.428 0 01-.986 4.223l-.896-.445a8.411 8.411 0 00.883-3.776c0-4.688-3.813-8.5-8.5-8.5-4.687 0-8.5 3.812-8.5 8.499 0 1.326.297 2.598.884 3.777l-.896.445A9.397 9.397 0 016.5 16zm11.342 7.475l-.342-.116v-2.566l.146-.146c.031-.032.854-.899.854-2.646 0-2.235-.116-3.5-2.5-3.5s-2.5 1.265-2.5 3.5c0 1.746.821 2.613.856 2.649l.141.146.003 2.563-.342.115c-.757.252-2.796 1.028-3.658 1.746v1.28l-1-.6v-1.107l.146-.146c.87-.871 3.014-1.698 3.854-2.002v-1.459c-.311-.393-1-1.457-1-3.186 0-2.005 0-4.5 3.5-4.5s3.5 2.495 3.5 4.5c0 1.729-.689 2.793-1 3.186v1.459c.84.304 2.982 1.131 3.854 2.002l.146.146V25.9l-1 .6v-1.279c-.863-.717-2.9-1.494-3.658-1.746z"/>'
  }
})
